import api, { Query } from './api'
import { Company } from './loadCompanies'

const loadPartnerCompanies = (partnerId: number, query?: Query): Promise<Company[]> =>
    api.get({ path: `/partners/${partnerId}/companies`, query })

export default loadPartnerCompanies
